export default __webpack_public_path__ + "images/16146efead69148aa9f9e8e20295ebea-international_affairs.webp";